import {Link} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/styled-react'

import {issueLinkedPullRequestHovercardPath} from '@github-ui/paths'
import type {Repository} from '@github-ui/current-repository'
import type {PullRequestStatus, PullRequest} from '../types'
import PullRequestMetadataLabel from './PullRequestMetadataLabel'

import styles from './PullRequestLabel.module.css'

interface PullRequestLabelProps {
  repo: Repository
  pullRequest: PullRequest
  sx?: BetterSystemStyleObject
}

function getStatus(pullRequest: PullRequest): PullRequestStatus {
  if (pullRequest.state === 'open' && pullRequest.reviewableState === 'draft') {
    return 'DRAFT'
  } else if (pullRequest.state === 'open') {
    return 'OPEN'
  } else if (pullRequest.merged) {
    return 'MERGED'
  } else {
    return 'CLOSED'
  }
}

function formatStatus(status: PullRequestStatus): string {
  if (!status) return ''
  return status[0] + status.slice(1).toLowerCase()
}

export default function PullRequestLabel({repo, pullRequest, sx}: PullRequestLabelProps) {
  const {permalink, number} = pullRequest
  const status = getStatus(pullRequest)
  return (
    <Link
      href={permalink}
      muted
      target="_blank"
      data-hovercard-url={issueLinkedPullRequestHovercardPath({
        owner: repo.ownerLogin,
        repo: repo.name,
        pullRequestNumber: number,
      })}
      aria-label={`${formatStatus(status)} pull request #${number}`}
      className={styles.PullRequestLink}
    >
      <PullRequestMetadataLabel kind="pull-request" number={pullRequest.number} status={status} sx={sx} />
    </Link>
  )
}

try{ PullRequestLabel.displayName ||= 'PullRequestLabel' } catch {}